import { USER_ROLES } from './constants';

export const DEFAULT_ROLE_PERMISSIONS = {
    [USER_ROLES.SUPER_ADMIN]: null,
    [USER_ROLES.HR_MANAGER]: ['dashboard', 'location_management', 'department_management', 'recruitment', 'onboarding', 'employee_management', 'hr_backoffice', 'attendance', 'payroll', 'performance', 'training', 'exit_management', 'compliance_policy', 'reports'],
    [USER_ROLES.HR_EXECUTIVE]: ['recruitment', 'onboarding', 'employee_management', 'attendance', 'training', 'performance'],
    [USER_ROLES.SALES_MANAGER]: ['dashboard', 'lead_management', 'field_sales', 'opportunity_management', 'quotation_management', 'order_management', 'customer_management', 'analytics', 'target_achievement', 'ticket_management'],
    [USER_ROLES.SALES_EXECUTIVE]: ['lead_management', 'field_sales', 'opportunity_management', 'quotation_management', 'order_management', 'customer_management', 'ticket_management'],
    [USER_ROLES.DISPATCH_MANAGER]: ['order_management'],
    [USER_ROLES.SUPPORT_MANAGER]: ['customer_management', 'ticket_management'],
    [USER_ROLES.CUSTOMER]: ['customer_management', 'order_management'],
    [USER_ROLES.EMPLOYEE]: ['self_service', 'my_attendance', 'my_payslip', 'leave_request', 'my_training', 'my_performance', 'policies', 'submit_resignation'],
    [USER_ROLES.TRAINEE]: ['self_service', 'my_attendance', 'my_payslip', 'leave_request', 'my_training', 'my_performance', 'policies', 'submit_resignation']
};

/**
 * Checks if a user has a specific granular permission
 */
export const hasPermission = (user, userRole, permissionKey) => {
    const role = userRole || user?.role;
    if (role === USER_ROLES.SUPER_ADMIN) {
        return true;
    }

    if (user && user.granularPermissions && user.granularPermissions[permissionKey] !== undefined) {
        const permission = user.granularPermissions[permissionKey];
        return permission && permission.read === true;
    }

    const defaultPerms = DEFAULT_ROLE_PERMISSIONS[role];
    if (defaultPerms && defaultPerms.includes(permissionKey)) {
        return true;
    }

    return false;
};

/**
 * Checks if user has any HRMS-related permissions
 */
export const hasHRMSPermission = (user, userRole) => {
    const role = userRole || user?.role;
    if (role === USER_ROLES.SUPER_ADMIN) return true;

    const hrmsPermissions = [
        'employee_management', 'recruitment', 'onboarding', 'hr_backoffice',
        'attendance', 'payroll', 'performance', 'training',
        'exit_management', 'compliance_policy', 'reports'
    ];

    return hrmsPermissions.some(permKey => hasPermission(user, role, permKey));
};

/**
 * Checks if user has any CRM-related permissions
 */
export const hasCRMPermission = (user, userRole) => {
    const role = userRole || user?.role;
    if (role === USER_ROLES.SUPER_ADMIN) return true;

    const crmPermissions = [
        'lead_management', 'field_sales', 'opportunity_management',
        'quotation_management', 'order_management', 'customer_management',
        'analytics', 'target_achievement'
    ];

    return crmPermissions.some(permKey => hasPermission(user, role, permKey));
};

/**
 * Checks if user is an employee or trainee (has self_service but no HRMS permissions)
 */
export const isEmployee = (user, userRole) => {
    const role = userRole || user?.role;
    if (role === USER_ROLES.SUPER_ADMIN) return false;
    if (role === USER_ROLES.EMPLOYEE || role === USER_ROLES.TRAINEE) return true;

    const hasSelfService = hasPermission(user, role, 'self_service');
    return hasSelfService && !hasHRMSPermission(user, role);
};

